import BasicHero from './BasicHero';
import React from 'react';

const BasicHeroWithProps = (props: any) => {
  return <BasicHero title={props.title} description={props.description} />;
};

export default BasicHeroWithProps;
